import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Warning status icon — warning triangle with exclamation mark.
 *
 * Dual-tone layered style:
 * - Triangle: cyan accent fill at 10%, currentColor outline
 * - Exclamation: vertical line + bottom dot, currentColor stroke
 *
 * Used for pending / warning pipeline states.
 */
export const WarningIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size} fill="none">
    {/* Warning triangle — cyan accent fill at 10% */}
    <path
      d="M 12 4 L 21 19 L 3 19 Z"
      fill="#00d4ff"
      fillOpacity={0.1}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Exclamation — vertical line */}
    <path
      d="M 12 9 L 12 14"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Exclamation — bottom dot */}
    <circle cx="12" cy="17" r="1" fill="currentColor" />
  </RushaSvgIcon>
);

WarningIcon.displayName = "WarningIcon";

export default WarningIcon;
